import React from 'react';

import { PageId } from 'utils/ubi/pageId';
import assemblePath from 'utils/assemblePath';

import InternalLink, { HrefFunction, LinkProps } from './InternalLink';

const articleLinkBuilderFactory =
  (slug: string): HrefFunction =>
  (market, verticalParam) =>
    assemblePath(market, verticalParam, 'article', slug);

interface ArticleLinkProps extends LinkProps {
  slug: string;
}

const ArticleLink = ({ slug, ...props }: ArticleLinkProps) => {
  return <InternalLink toPage={PageId.Article} hrefFun={articleLinkBuilderFactory(slug)} {...props} />;
};

export default ArticleLink;
